<div>
    <h6>
        Inloggning misslyckades, behörighet saknas
    </h6>
    <div>
        <button class="btn btn-primary" (click)="reset()">Återställ / Försök igen</button>
    </div>
</div>
